<script setup>
import { defineAsyncComponent, ref, computed, onMounted, watch } from "vue";
import { useStore } from "vuex";
import ToastOverlay from "./views/ToastOverlay.vue";
import ToastOverlayHistorical from "./views/ToastOverlayHistorical.vue";


// grab state
const store = useStore();
const initialFadeIn = ref(false);
const isHistorical = ref(true);


// The Chart component and 'chart.js' package won't load until showChart is true
const SocketConnector = defineAsyncComponent(() => import('./views/SocketConnector.vue'));

const minimzedTransition = computed(() => {
  return store.getters.isAppMinimized ? `to-minimized` : `from-minimized`;
});


onMounted(() => {

  initialFadeIn.value = true;
})

</script>

<template>
  <div>
    <ToastOverlay v-if = "!isHistorical"></ToastOverlay>
    <ToastOverlayHistorical v-else></ToastOverlayHistorical>

    <SocketConnector v-if = "initialFadeIn"></SocketConnector>
    <div class = "force-load-p">
      a
    </div>
    <div class="force-load-b">
      a
    </div>
  </div>
  
</template>

<style lang="scss" scoped>

@import './sass/GlobalClasses';
@import './sass/Settings';
@import './sass/Transitions';

.force-load-p {
  visibility: hidden;
  font-family: "UFCSans";
}

.force-load-b {
  visibility: hidden;
  font-family: "UFCSans";
  font-weight: bold;
}

.full-container{
  position: relative;
  width: vw(600);
  height:vw(600);
}

.image-viewer-container{
  position: relative;
  width: vw(600);
  height: auto;
}

.pagination-area {
  position: fixed;
  width: 100%;
  height: auto;
  bottom: 0;
  left: 0;

  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;

  .pagination {
    position: relative;
    width: vw(8);
    height: vw(8);
    border-radius: vw(4);
    background-color: #DFDFDF;
    margin: 0 vw(3);
  }

  .active-pagination {
    width: vw(12);
    height: vw(12);
    border-radius: vw(6);
    background-color: #FFFFFF;
  }
}

</style>
